import _classCallCheck from "/data/jenkins/workspace/jd-bi-web/jd-bi-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/jenkins/workspace/jd-bi-web/jd-bi-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var Container =
/*#__PURE__*/
function () {
  function Container(hook) {
    _classCallCheck(this, Container);

    this.hook = hook;
    this.subscribers = new Set();
  }

  _createClass(Container, [{
    key: "notify",
    value: function notify() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.subscribers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var subscriber = _step.value;
          subscriber(this.data);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }]);

  return Container;
}();